import isolate from "@cycle/isolate"

import * as R from "ramda"

import { STATE_KEY, INPUT_CHECK } from "../../../../constant"

import {
  createCheckInfo,
} from "../../../common"
import { InputCheck, ModificationType} from "../../../../interface"

import { view } from "./view"
import { Confirm, Form } from ".."

const INPUT_CHECKS: InputCheck[] = [
  INPUT_CHECK["telWithdrawal"],
  createCheckInfo("when", /./, "退会時期を選択してください。"),
]

export default isolate(Form("withdrawal", STATE_KEY.WithdrawalForm, view, INPUT_CHECKS))

const getReqParam = ([user, form] : [any, any]) => {
  const type = ModificationType.Withdrawal
  const memberId = R.prop("id", user)
  return {
    type, memberId, body: form,
  }
}

export const WithdrawalConfirm = isolate(Confirm(STATE_KEY.WithdrawalForm, view, getReqParam))
